import BreadCrumbs from 'components/breadcrumbs'
import DetailPage from '../payable-notes/DetailPage'

const DetailReceivable = () => {
  return (
    <>
      <div className="w-100 px-3">
        <div className="d-flex align-items-start gap-2 pt-3">
          <BreadCrumbs breadCrumbActive={'Piutang'} />
        </div>
        <DetailPage isReceivable={true} />
      </div>
    </>
  )
}

export default DetailReceivable
